/** @griffel:css-start [d] null **/
.fz5stix{white-space:nowrap;}
.fi64zpg{flex-shrink:0;}
.f11khh7q{block-size:24px;}
.f1ewtqcl{box-sizing:border-box;}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f44lkw9{border-radius:var(--borderRadiusCircular);}
.f1ifyi5{padding-inline:10px;}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.f1ufnopg{column-gap:var(--spacingHorizontalXS);}
.f1ugzwwg{font-size:12px;}
.f104wqfl{line-height:16px;}
.fdj6btp{font-weight:var(--fontWeightMedium);}
.f1u9dzx2{border-inline-start-color:var(--colorTransparentStroke);}
.f19bg87z{border-inline-end-color:var(--colorTransparentStroke);}
.f14bxww4{border-block-start-color:var(--colorTransparentStroke);}
.f1sp4c52{border-block-end-color:var(--colorTransparentStroke);}
.f1wl9k8s::before{content:"";}
.fd1hv5k::before{display:inline-block;}
.f1s9zyos::before{flex-shrink:0;}
.fnny5tc::before{inline-size:6px;}
.f1dzc99s::before{block-size:6px;}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.fielpny::before{border-radius:var(--borderRadiusCircular);}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.f3e8jtw::before{background-color:currentColor;}
.fjookjo::before{display:none;}
.fhbnykk{color:var(--bfStatusSuccessForeground);}
.f18r3lq8{background-color:var(--bfStatusSuccessBackground);}
.fhc94cr{color:var(--bfStatusWarningForeground);}
.f1ynw2h5{background-color:var(--bfStatusWarningBackground);}
.f19tbz2r{color:var(--bfStatusDangerForeground);}
.f1tmgct3{background-color:var(--bfStatusDangerBackground);}
.fewp24t{color:var(--bfStatusInfoForeground);}
.f4xskf5{background-color:var(--bfStatusInfoBackground);}
.fgvac7k{color:var(--bfStatusNeutralForeground);}
.f19zq2xs{background-color:var(--bfStatusNeutralBackground);}
/** @griffel:css-end **/